import React from 'react';
import styled from 'styled-components';

import ColoredRectangle from './ColoredRectangle';

const LAPTOP_HEIGHTS = {
  leftTop: 164,
  bottom: 452,
  rightTop: 819,
};

const rectanglesConfig = {
  left: {
    top: [
      {
        text: 'Strong Black',
        fillColor: '#1A1A1A',
        textColor: 'white',
        textPositioning: 'centerLeft',
      },
      {
        text: 'Dark Grey',
        fillColor: '#9192A1',
        textColor: 'white',
        textPositioning: 'centerLeft',
      },
      {
        text: 'Medium Grey',
        fillColor: '#C2C2D5',
        textColor: 'black',
        textPositioning: 'centerLeft',
      },
      {
        text: 'Light Grey',
        fillColor: '#E4E9FB',
        textColor: 'black',
        textPositioning: 'centerLeft',
      },
      {
        text: 'Background White',
        fillColor: '#F3F5F9',
        textColor: 'black',
        textPositioning: 'centerLeft',
      },
    ],
    bottom: [{text: 'Red Color Coding', fillColor: '#EB4C55', textColor: 'white'}],
  },
  right: {
    top: [{text: 'Brand Blue', fillColor: '#2831F4', textColor: 'white'}],
    bottom: [{text: 'Green Color Coding', fillColor: '#1AA053', textColor: 'white'}],
  },
};

const RectanglesContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  margin: 0 160px;
  gap: 16px;
`;

const RectanglesWrapper = styled.div`
  display: flex;
  flex-flow: column;
  width: 50%;
`;

const RectanglesGapWrapperVertical = styled(RectanglesWrapper)`
  gap: 16px;
`;

const RectanglesGapWrapperHorizontal = styled(RectanglesWrapper)`
  flex-flow: row;
  width: 100%;
  gap: 16px;
  margin-top: 16px;
`;

const LaptopRectanglesLayout = () => {
  const renderLeftTopRectangles = () =>
    rectanglesConfig.left.top.map((rectangle) => (
      <ColoredRectangle
        key={rectangle.text}
        text={rectangle.text}
        textColor={rectangle.textColor}
        fillColor={rectangle.fillColor}
        height={LAPTOP_HEIGHTS.leftTop}
        textPositioning={rectangle.textPositioning}
      />
    ));

  const renderLeftBottomRectangles = () =>
    rectanglesConfig.left.bottom.map((rectangle) => (
      <ColoredRectangle
        key={rectangle.text}
        text={rectangle.text}
        textColor={rectangle.textColor}
        fillColor={rectangle.fillColor}
        height={LAPTOP_HEIGHTS.bottom}
        textPositioning={rectangle.textPositioning}
      />
    ));

  const renderRightTopRectangle = () =>
    rectanglesConfig.right.top.map((rectangle) => (
      <ColoredRectangle
        key={rectangle.text}
        text={rectangle.text}
        textColor={rectangle.textColor}
        fillColor={rectangle.fillColor}
        height={LAPTOP_HEIGHTS.rightTop}
        textPositioning={rectangle.textPositioning}
      />
    ));
  const renderRightBottomRectangle = () =>
    rectanglesConfig.right.bottom.map((rectangle) => (
      <ColoredRectangle
        key={rectangle.text}
        text={rectangle.text}
        textColor={rectangle.textColor}
        fillColor={rectangle.fillColor}
        height={LAPTOP_HEIGHTS.bottom}
        textPositioning={rectangle.textPositioning}
      />
    ));

  return (
    <RectanglesContainer>
      <RectanglesWrapper>
        {renderLeftTopRectangles()}
        <RectanglesGapWrapperHorizontal>{renderLeftBottomRectangles()}</RectanglesGapWrapperHorizontal>
      </RectanglesWrapper>
      <RectanglesGapWrapperVertical>
        {renderRightTopRectangle()}
        {renderRightBottomRectangle()}
      </RectanglesGapWrapperVertical>
    </RectanglesContainer>
  );
};

export default LaptopRectanglesLayout;
